import { useSelector } from 'react-redux'
import { getVehicleDiscounts } from 'utils/vehicles'
import { useIntl } from 'react-intl'

const useVehicleResume = (vehicle) => {
  const { formatMessage: f } = useIntl()
  const { extras, vehicleOffer, steps: { personalInformation } } = useSelector((s) => s.checkout)
  const {
    titleDiscount,
    finalPrice,
  } = getVehicleDiscounts(vehicle)
  const showVehicleOffer = Object.keys(vehicleOffer).length > 0
    && vehicleOffer.show_price && vehicleOffer.price < finalPrice
  const extrasMapped = extras.map((extra) => {
    return {
      ...extra,
      isActive: true,
    }
  })
  const listPrices = [
    ...extrasMapped,
    /*     {
      title: titleDiscount,
      price: amountDiscount,
      operation: getOperation(operation),
      isActive: hasDiscount,
    }, */
  ]
  if (showVehicleOffer) {
    listPrices.push(
      {
        title: f({ id: 'CHECKOUT_SIMPLIFIED_MODAL_CAR_ON_ACCOUNT' }),
        price: vehicleOffer.price,
        operation: '-',
        isActive: true,
      },
    )
  }
  return {
    listPrices,
    showVehicleOffer,
    finalPrice,
    titleDiscount,
    personalInformation,
  }
}

export default useVehicleResume
